import type { PdfTableColumn, PdfTableExportOptions } from "../../../shared/services/export/pdf/pdfExport.types";
import type { NewReportDataItem } from "../../../api/client/types/new.types";

/**
 * PDF column definitions for the news report.
 * Widths mirror backend `get_news_columns_for_pdf()` exactly so proportions
 * match the Excel export.
 */
export const NEWS_PDF_COLUMNS: PdfTableColumn<NewReportDataItem>[] = [
  { header: "FECHA",                     accessor: (r) => r.date.split(" ")[0],       widthWeight: 13, align: "CENTER" },
  { header: "UNIDAD",                    accessor: (r) => r.building_name,            widthWeight: 13, align: "CENTER" },
  { header: "SALVAVIDAS DE TURNO",       accessor: (r) => r.lifeguard_name,           widthWeight: 15, align: "CENTER" },
  { header: "TIPO DE NOVEDAD",           accessor: (r) => r.report_type_name,         widthWeight: 15, align: "CENTER" },
  { header: "NOVEDAD",                   accessor: (r) => r.news_type_name,           widthWeight: 15, align: "CENTER" },
  { header: "HORA DE NOVEDAD",           accessor: (r) => r.event_time,               widthWeight: 13, align: "CENTER" },
  { header: "NIVEL DE INTERVENCION",     accessor: (r) => r.intervention_level_name,  widthWeight: 17, align: "CENTER" },
  { header: "NOMBRE DEL BAÑISTA",        accessor: (r) => r.swimmer_name,             widthWeight: 15, align: "CENTER" },
  { header: "TORRE/\nAPTO",              accessor: (r) => r.tower_apartment,          widthWeight: 11, align: "CENTER" },
  { header: "EDAD",                      accessor: (r) => r.age_classification_name,  widthWeight: 13, align: "CENTER" },
  { header: "ADULTO RESPONSABLE",        accessor: (r) => r.responsible_name,         widthWeight: 17, align: "CENTER" },
  { header: "DESCRIPCION DE LOS HECHOS", accessor: (r) => r.event_description,        widthWeight: 71, align: "LEFT", valign: "TOP" },
  { header: "OFICIAL DE SEGURIDAD",      accessor: (r) => r.security_officer_name,    widthWeight: 14, align: "CENTER" },
];

/**
 * Shared PDF layout options for the news report.
 * Excludes per-call fields (`columns`, `rows`, `fileName`, `onError`).
 */
export const NEWS_PDF_OPTIONS = {
  title: "CENTRAL DE COMUNICACIONES - BITACORA DE NOVEDADES OPERACIONALES",
  orientation: "landscape",
  format: "letter",
  headerFillColor: [255, 255, 0],
  logoUrl: "/report_logo.png",
  logoWidth: 16,
  fontSize: 6,
  cellPadding: 0.6,
  headerCellPadding: 1,
  horizontalMargin: 10,
  /** Body cells vertically centered except columns with an explicit `valign` (e.g. description). */
  bodyValign: "MIDDLE",
} satisfies Omit<PdfTableExportOptions<NewReportDataItem>, "columns" | "rows" | "fileName" | "onError" | "onSuccess">;
